// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"c961907c","185":"011e37cb","241":"772e0810","277":"3115d9e0","488":"559b4da8","574":"b0064942","575":"cae8ebfd","650":"18ffc8f9","734":"d3b9fae3","789":"e92ffb22","939":"7d6e3ac6"}[chunkId] + ".chunk.js";
};